import React from 'react';

/** items: [{ key, label, sub? }] */
export default function Segmented({ items, value, onChange, className = '', ariaLabel }) {
  return (
    <div className={`segmented ${className}`} role="tablist" aria-label={ariaLabel}>
      {items.map((it) => (
        <button
          key={it.key}
          type="button"
          role="tab"
          aria-selected={value === it.key}
          className={`segmented__item ${value === it.key ? 'segmented__item--active' : ''}`}
          onClick={() => onChange(it.key)}
        >
          {it.label}
          {it.sub && <span className="segmented__sub">{it.sub}</span>}
        </button>
      ))}
    </div>
  );
}
